import React, { useState, useRef } from "react";
import { connect } from 'react-redux'
import { BiEdit } from "react-icons/bi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Button, Modal } from "react-bootstrap";
import AgGridTable from "../AgGridTable";
import {
    addCategoryAction,
    updateCategoryAction,
    deleteCategoryAction
} from '../../../redux/actions/admin/adminAction';
import Select from "react-select";
import { groupdata } from '../helper/index'

export const Category = (props) => {
    const gridRef = useRef();

    const [inputData, setInputData] = useState({ 'category': '', 'function': '' })
    const [show, setShow] = useState(false);

    const customStyles = {
        control: (base, state) => ({
            ...base,
            top: "5px",
            // Overwrittes the different states of border
            borderColor: state.isFocused ? "#309CCA" : "#309CCA",
        }),
    };

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setInputData({ 'category': '', 'function': '' })
        setShow(false)
    };

    const handleSeclect = (event) => {
        setInputData((prevstate) => ({
            ...prevstate,
            ['function']: event.id
        }))
    }


    const handleChange = (event) => {
        setInputData((prevstate) => ({
            ...prevstate,
            [event.target.name]: event.target.value
        }))
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (inputData['id']) {
            props.updateCategory(inputData.id, inputData)
            handleClose()
        }
        else {
            props.addCategory(inputData)
            handleClose()
        }
    };

    const handleSetData = (data) => {
        setInputData(data)
        handleShow()
    }

    const handleDelete = (id) => {
        props.deleteCategory(id)
    }


    const [categoryColumnDefs] = useState([
        { headerName: "Id", field: 'id', sort: 'asc' },
        { headerName: "category", field: 'category', filter: true, },
        { headerName: "Function", field: 'function_name', filter: true, },
        {
            headerName: "Actions", field: 'action',
            cellRendererFramework: (params) => <>
                <BiEdit color="blue" size={20} onClick={() => handleSetData(params.data)} cursor='pointer' />
                <RiDeleteBin6Line color="red" size={20} onClick={() => handleDelete(params.data.id)} cursor='pointer' />
            </>,
            cellStyle: { textAlign: 'center' }
        },
    ])

    const defaultColDef = {
        flex: 1,
        floatingFilter: true,
        sortable: true,
        editable: false,
    }

    return (
        <div>
            <div align='right'>
                <button className="btn btn-blue"
                    onClick={() => handleShow()}
                    style={{ marginBottom: "10px" }}>Add</button>
            </div>

            <AgGridTable
                ref={gridRef}
                data={groupdata(props.functions, props.category, 'function', 'function_name')}
                defaultColDef={defaultColDef}
                columnDefs={categoryColumnDefs} />

            {/* Add Form */}
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Category</Modal.Title>
                </Modal.Header>

                <form onSubmit={handleSubmit}>
                    <Modal.Body>
                        <h3>Category</h3>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                id="category"
                                name="category"
                                value={inputData.category}
                                onChange={handleChange}
                                placeholder="Category"
                                autoComplete="off"
                            />
                        </div>
                        <br></br>
                        <h3>Function</h3>
                        <div className="">
                            <Select
                                id="sector"
                                name="sector"
                                options={props.functions}
                                value={inputData.function ?
                                    props.functions.find(
                                        (row) =>
                                            row.id === inputData.function) :
                                    null
                                }
                                getOptionLabel={(option) => option.function}
                                getOptionValue={(option) => option.id}
                                onChange={(event) => handleSeclect(event)}
                                placeholder="Choose.."
                                isClearable={true}
                                styles={customStyles}

                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Modal.Footer>

                </form>
            </Modal>
        </div >
    )
}

const mapStateToProps = (state) => {
    const functions = state.admin.functions;
    const category = state.admin.category;

    return {
        functions: functions,
        category: category,
    };
};

const mapDispatchToProps = (dispatch, state) => {
    return {
        addCategory: (data) => dispatch(addCategoryAction(data)),
        updateCategory: (id, data) => dispatch(updateCategoryAction(id, data)),
        deleteCategory: (id) => dispatch(deleteCategoryAction(id)),

    };
};


export default connect(mapStateToProps, mapDispatchToProps)(Category);